import type { ColumnDef } from '@tanstack/react-table'

export const usersColumns: ColumnDef<any>[] = [
  { name: 'email', type: 'text' },
  { name: 'user_id', type: 'uuid' },
].map((column) => ({
  header: () => <div className="text-left">{column.name}</div>,
  accessorKey: column.name,
}))

export const usersCSVColumns: {
  name: string
  type: string
  nullable: boolean
}[] = [
  { name: 'email', type: 'text', nullable: false },
  { name: 'user_id', type: 'uuid', nullable: false },
  { name: 'login_time', type: 'date', nullable: false },
]

export const getUsersUrl = (projectId: string) => {
  return `/api/me/project/${projectId}/users`
}

export const getTablesUrl = (projectId: string) => {
  return `/api/me/project/${projectId}/tables`
}

export const getTableUrl = (projectId: string, tableName: string, page = 1) => {
  return `/api/me/project/${projectId}/table/${tableName}?page=${page}`
}
